module.exports = __webpack_public_path__ + "static/media/Funding.a413bad2.png";